<script lang="ts">
  import type { Flashcard } from '../../types/flashcard';
  import { X } from 'lucide-svelte';
  import { _ } from 'svelte-i18n';
  import FSRSReviewMode from '../FSRSReviewMode.svelte';

  let {
    open = false,
    flashcardList,
    onClose = () => {},
    onComplete,
  }: {
    open?: boolean;
    flashcardList: Flashcard[];
    onClose?: () => void;
    onComplete?: () => void;
  } = $props();

  function handleClose() {
    onClose?.();
  }

  function handleBackdropClick(event: MouseEvent) {
    // Don't close on backdrop click for review mode
    // Users might accidentally click while reviewing
  }

  function handleKeydown(event: KeyboardEvent) {
    if (event.key === 'Escape') {
      handleClose();
    }
  }

  function handleComplete() {
    onComplete?.();
    handleClose();
  }
</script>

{#if open}
  <div
    class="fixed inset-0 z-[96] flex flex-col dialog-overlay"
    role="dialog"
    aria-modal="true"
    tabindex="0"
    onclick={handleBackdropClick}
    onkeydown={handleKeydown}
  >
    <div class="dialog-close dialog-close--fixed">
      <button
        type="button"
        class="btn btn-close"
        onclick={handleClose}
        aria-label={$_('buttons.cancel')}
      >
        <X class="h-5 w-5" />
      </button>
    </div>

    <div class="h-full w-full overflow-hidden">
      <FSRSReviewMode
        {flashcardList}
        onBack={handleClose}
        onComplete={handleComplete}
      />
    </div>
  </div>
{/if}
